import React from 'react';
import {
  Box,
  Card,
  CardContent,
  Chip,
  Stack,
  Typography,
} from '@mui/material';

const riskColor = {
  low: 'success',
  elevated: 'info',
  medium: 'warning',
  high: 'error',
  critical: 'error',
};

export const RiskChip = ({ riskLevel }) => (
  <Chip
    size="small"
    color={riskColor[riskLevel] || 'default'}
    label={(riskLevel || 'low').toUpperCase()}
    sx={{ fontWeight: 600 }}
  />
);

export const MetricCard = ({ title, value, description, icon }) => (
  <Card elevation={1}>
    <CardContent>
      <Stack direction="row" alignItems="center" spacing={2}>
        {icon}
        <Box>
          <Typography variant="subtitle2" color="text.secondary">
            {title}
          </Typography>
          <Typography variant="h5" sx={{ fontWeight: 600 }}>
            {value}
          </Typography>
          {description && (
            <Typography variant="caption" color="text.secondary">
              {description}
            </Typography>
          )}
        </Box>
      </Stack>
    </CardContent>
  </Card>
);
